module.exports = __webpack_public_path__ + "static/media/city-elements-facilities-13-svgrepo-com.f1da5f13.svg";